module.exports = __webpack_public_path__ + "img/charges.eeac9651.svg";